export default "<h1 class=\"text-center\">ERRO 404</h1>\n<p class=\"text-center\">Página não encontrada!</p>\n"